import classNames from 'classnames';
import { Form, Formik, FormikConfig, FormikValues } from 'formik';
import { PropsWithChildren, ReactElement, memo } from 'react';
import { Button } from '../../Button';
// import { Button } from '../../Button';
import { T } from '../../../translation/src';
import { Modal } from '../../Modal';

interface CreateModalProps<FormValues extends FormikValues = FormikValues> {
  onClose?: () => void;
  onCancel?: () => void;
  open?: boolean;
  title: React.ReactNode;
  formik: FormikConfig<FormValues>;
  createButtonTitle?: React.ReactNode;
  cancelButtonTitle?: React.ReactNode;
  hideSubmitButton?: React.ReactNode;
  modalBodyClassName?: string;
  modalContainerClassName?: string;
  panelClassName?: string;
  isSubmitting?: boolean;
  formClassName?: string;
  noOverflow?: boolean;
  onlyCloseOnButtonClick?: boolean;
  alwaysCancellable?: boolean;
  footerMessage?: React.ReactNode;
  showCloseIcon?: boolean;
  // Holds the submit back while the form cannot be confirmed as it stands (invalid, or waiting on the server).
  submitDisabled?: boolean;
}

const CreateModal_ = <FormValues extends FormikValues = FormikValues>({
  onClose,
  onCancel,
  open,
  title,
  createButtonTitle,
  cancelButtonTitle,
  formik,
  modalBodyClassName,
  modalContainerClassName,
  panelClassName,
  formClassName,
  children,
  isSubmitting,
  noOverflow,
  hideSubmitButton,
  onlyCloseOnButtonClick,
  alwaysCancellable,
  footerMessage,
  showCloseIcon,
  submitDisabled,
}: PropsWithChildren<CreateModalProps<FormValues>>): ReactElement | null => {
  return (
    <Modal.Container onClose={onlyCloseOnButtonClick ? undefined : onClose} open={open} className={modalContainerClassName} panelClassName={panelClassName} noOverflow={noOverflow}>
      <Formik<FormValues> {...formik}>
        <Form className={classNames('flex flex-col w-full h-full', formClassName)}>
          <Modal.Header onClose={showCloseIcon ? onClose : undefined}>{title}</Modal.Header>
          <Modal.Body className={modalBodyClassName}>{children}</Modal.Body>
          <Modal.Footer className="flex-col !items-start">
            <div className="flex space-x-4">
              {!hideSubmitButton && (
                <Button variant="primary" type="submit" loading={isSubmitting} disabled={submitDisabled}>
                  {createButtonTitle || <T _str="submit" swc />}
                </Button>
              )}
              <Button variant="secondary" onClick={onCancel ? onCancel : onClose} disabled={isSubmitting && !alwaysCancellable}>
                {cancelButtonTitle ? cancelButtonTitle : <T _str="cancel" swc />}
              </Button>
            </div>
            {footerMessage && <div className="mt-3 text-left">{footerMessage}</div>}
          </Modal.Footer>
        </Form>
      </Formik>
    </Modal.Container>
  );
};

export const CreateModal = memo(CreateModal_) as typeof CreateModal_;
